/**
 * Ids of the titles that shipped with the app, as `seed:<title>-<year>`.
 *
 * Those ids are already referenced by watchlists, ratings and persisted
 * sessions, so they survived every rewrite of where films are stored — which
 * makes them the one id family that can still be recognized on sight.
 */
export const SEED_ID_PREFIX = 'seed:';
/**
 * Ids of titles from The Movie Database, as `tmdb:<numeric id>`. Everything
 * the deck deals since the catalog moved to TMDB carries one.
 */
export const TMDB_ID_PREFIX = 'tmdb:';
/**
 * Whether a card came from somebody here rather than from the shipped seed.
 *
 * Deliberately "not shipped" rather than a prefix of its own: community films
 * have had three id shapes over the app's life — `suggestion:<id>` from the
 * old hub, `film:<id>` for the ones carried over from it, and a plain id for
 * anything added since — and a badge that lists the shapes it knows about is
 * a badge that quietly stops appearing the next time one is added.
 */
export function isCommunityMovie(movieId) {
    // TMDB titles are neither shipped nor proposed here, but they are certainly
    // not the community's either — a "community" badge on them would be false.
    return !movieId.startsWith(SEED_ID_PREFIX) && !movieId.startsWith(TMDB_ID_PREFIX);
}
/** The title to display for a viewer in `locale`, falling back to `title`. */
export function resolveMovieTitle(movie, locale) {
    return movie.titles?.[locale] ?? movie.title;
}
export const VOTE_POINTS = {
    like: 1,
    neutral: 0,
    dislike: -1,
};
export const SESSION_CODE_LENGTH = 6;
/** Ambiguous characters (0/O, 1/I) are left out so codes can be read aloud. */
export const SESSION_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
